var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.clickable)?_c('div',{class:_vm.$style.icon,style:(_vm.style)}):_c('button',{class:_vm.$style.icon,style:(_vm.style),attrs:{"data-clickable":""}})}
var staticRenderFns = []

export { render, staticRenderFns }